import { render } from "./MypageFoodsRankingContentFoodsRankingCard.vue?vue&type=template&id=5f67bd2a&scoped=true&ts=true"
import script from "./MypageFoodsRankingContentFoodsRankingCard.vue?vue&type=script&lang=ts"
export * from "./MypageFoodsRankingContentFoodsRankingCard.vue?vue&type=script&lang=ts"

import "./MypageFoodsRankingContentFoodsRankingCard.vue?vue&type=style&index=0&id=5f67bd2a&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f67bd2a"]])

export default __exports__